import { MenuItem } from 'react-bootstrap'
import Chip, { ChipVariants } from 'components/Chip'

export interface AccountMenuItemProps {
  eventKey: number
  href?: string
  onClick?: (arg0: any) => void
  label?: string
  chipLabel?: string
  chipVariant?: (typeof ChipVariants)[keyof typeof ChipVariants]
  type?: string
}

export const AccountMenuItem = ({
  eventKey,
  href,
  onClick,
  label,
  chipLabel,
  chipVariant = ChipVariants.DEFAULT,
  type,
}: AccountMenuItemProps) => {
  if (type === 'divider') {
    return <MenuItem divider />
  }
  return (
    <MenuItem eventKey={eventKey} href={href} onClick={onClick}>
      <div className="flex">
        <span className="flex flex-grow">{label}</span>
        {chipLabel && (
          <Chip
            className="mlm"
            label={chipLabel}
            size="small"
            variant={chipVariant}
          />
        )}
      </div>
    </MenuItem>
  )
}
